import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useHistory } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import { userServices } from "../../Services/user.service";
import ListAdminButtons from "../Common/ListAdminButtons";
import DeleteModal from "./DeleteModal";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import SpinnerLoading from "../Common/SpinnerLoading";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { globalServices } from "../../Services/global.service";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { roles } from "../../Config/Roles";
import Tooltip from "../Common/Tooltip";
import AsyncSelect from "react-select/async";
import { set } from "date-fns";

const Index = () => {
  const {
    updateLocName,
    updateLocTenant,
    updateLocStore,
    updateLocPos,
    updateLocUser,
    updateLocTab,
    updateLocKey,
    isMobile,
    locTenant,
  } = useContext(GlobalContext);
  const { userId, roleId } = useContext(AuthContext);
  const { master, admin, support, owner, manager, cashier, accountant } = roles;
  const { t: translator } = useTranslation();
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [tenantObj, setTenantObj] = useState({
    id: 0,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });
  const [update, setUpdate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [search, setSearch] = useState({
    tenantId:
      Number(localStorage.getItem("tenantId")) > 0
        ? Number(localStorage.getItem("tenantId"))
        : 0,
    searchText: "",
    isDeactivated: false,
    sortName: "RealName",
    isAsc: true,
  });
  const history = useHistory();

  useEffect(() => {
    userServices
      .get({
        tenantId: search.tenantId,
        searchName: search.searchText,
        isDeactivated: search.isDeactivated,
        sortName: search.sortName,
        isAsc: search.isAsc,
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((res) => {
        setUsers(res.data.data);
        setPagination({ ...pagination, totalCount: res.data.totalCount });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });

    updateLocName("users");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocUser(0);
    updateLocTab(0);
    updateLocKey(0);
  }, [update, search]);

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));
        result.unshift({
          id: 0,
          label: translator("SelectTenant-Choose"),
          oib: "",
        });
        return result;
      })
      .catch((err) => err);
  };

  const handleToAdd = () => {
    history.push("/adduser");
  };

  const handleRefresh = () => {
    setIsLoading(true);
    setPagination({ ...pagination, pageIndex: 0 });
    setUpdate(new Date());
  };

  const handleClose = () => {
    setModal({ show: false });
    history.push("/users");
  };

  const handleToUpdate = () => {
    if (selectedItems.length !== 1) return false;
    history.push(`/update-user/${selectedItems}`);
  };

  const handleToDetail = () => {
    if (selectedItems.length !== 1) return false;
    history.push(`/users/${selectedItems}`);
  };

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedItems([...selectedItems, row.userId]);
    } else {
      setSelectedItems(selectedItems.filter((p) => p !== row.userId));
    }
  };

  const handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      setSelectedItems(users.map((x) => x.userId));
    } else {
      setSelectedItems([]);
    }
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (e.target.cellIndex) {
        history.push(`/users/${row.userId}`);
      }
    },
  };

  const handleHideDeleteModal = () => setShowDeleteModal(false);

  const confirmDelete = () => {
    let deletePromises = [];

    selectedItems.forEach((x) => {
      deletePromises.push(userServices.deleteUser(x));
    });

    Promise.all(deletePromises)
      .then((data) => {
        setShowDeleteModal(false);
        setModal({
          ...modal,
          title: "Users-ResultModal-DeleteSuccess-Title",
          text: "Users-ResultModal-DeleteSuccess-Text",
          show: true,
          btnClass: "btn btn-primary",
        });
        setUpdate(new Date());
      })
      .catch((err) =>
        setModal({
          ...modal,
          title: "Users-ResultModal-DeleteError-Title",
          text: "Users-ResultModal-DeleteError-Text",
          show: true,
          btnClass: "btn btn-primary",
        })
      );
  };

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    style: { backgroundColor: "rgb(248, 248, 248)" },
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    setIsLoading(true);
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  const sorting = (sortName) => {
    setSearch({ ...search, sortName, isAsc: !search.isAsc });
  };

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            checked={selectedItems.find((x) => x === row.userId)}
            onChange={(e) => handleOnSelect(row, e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  function actionHeaderFormatter(cell, rows) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            checked={
              users &&
              users.length > 0 &&
              !users
                .map((p) => p.userId)
                .some((p) => selectedItems.indexOf(p) < 0)
            }
            onChange={(e) => handleOnSelectAll(e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  const CustomToggleList = ({ columns, onColumnToggle, toggles }) => (
    <div className="row pl-2">
      {columns
        .slice(1)
        .map((column) => ({
          ...column,
          toggle: toggles[column.dataField],
        }))
        .map((column) => (
          <span className="ml-2">
            <label className="labelCont pl-4">
              <input
                type="checkbox"
                key={column.dataField}
                checked={column.toggle}
                className={`${column.toggle ? "active" : ""}`}
                aria-pressed={column.toggle ? "true" : "false"}
                onClick={() => onColumnToggle(column.dataField)}
              />
              <span className="checkmark"></span>
            </label>
            <span>{column.text}</span>
          </span>
        ))}
    </div>
  );

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <ToolkitProvider
        keyField="userId"
        data={data}
        columns={columns}
        columnToggle
      >
        {(props) => (
          <>
            {/* <CustomToggleList {...props.columnToggleProps} /> */}
            <hr />
            <BootstrapTable
              remote
              rowEvents={rowEvents}
              rowClasses="boostrap-table-row"
              noDataIndication={translator("No-Data")}
              pagination={paginationFactory({
                page,
                sizePerPage,
                totalSize,
              })}
              onTableChange={onTableChange}
              {...props.baseProps}
            />
          </>
        )}
      </ToolkitProvider>
    </div>
  );

  const columns = [
    {
      dataField: "userId",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      headerFormatter: actionHeaderFormatter,
      formatter: actionFormatter,
      hidden: [cashier].includes(Number(roleId)) ? true : false,
    },
    {
      dataField: "realName",
      text: translator("Users-View-TableHeader-FullName"),
      headerEvents: { onClick: () => sorting("RealName") },
      sort: true,
      sortCaret: (order, column) => {
        if (search.sortName !== "RealName")
          return <i className="fa fa-fw fa-sort"></i>;
        if (search.sortName === "RealName") {
          return search.isAsc !== true ? (
            <i className="fa fa-fw fa-sort-up"></i>
          ) : (
            <i className="fa fa-fw fa-sort-down"></i>
          );
        }
      },
    },
    {
      dataField: "loginName",
      text: translator("Users-View-TableHeader-Username"),
      headerEvents: { onClick: () => sorting("LoginName") },
      sort: true,
      sortCaret: (order, column) => {
        if (search.sortName !== "LoginName")
          return <i className="fa fa-fw fa-sort"></i>;
        if (search.sortName === "LoginName") {
          return search.isAsc === true ? (
            <i className="fa fa-fw fa-sort-up"></i>
          ) : (
            <i className="fa fa-fw fa-sort-down"></i>
          );
        }
      },
      hidden: Boolean(isMobile),
    },
    {
      dataField: "email",
      text: "Email",
      headerEvents: { onClick: () => sorting("Email") },
      sort: true,
      sortCaret: (order, column) => {
        if (search.sortName !== "Email")
          return <i className="fa fa-fw fa-sort"></i>;
        if (search.sortName === "Email") {
          return search.isAsc === true ? (
            <i className="fa fa-fw fa-sort-up"></i>
          ) : (
            <i className="fa fa-fw fa-sort-down"></i>
          );
        }
      },
      hidden: Boolean(isMobile),
    },
    {
      dataField: "phone",
      text: translator("Users-View-TableHeader-PhoneNumber"),
      headerEvents: { onClick: () => sorting("Phone") },
      sort: true,
      sortCaret: (order, column) => {
        if (search.sortName !== "Phone")
          return <i className="fa fa-fw fa-sort"></i>;
        if (search.sortName === "Phone") {
          return search.isAsc === true ? (
            <i className="fa fa-fw fa-sort-up"></i>
          ) : (
            <i className="fa fa-fw fa-sort-down"></i>
          );
        }
      },
      hidden: Boolean(isMobile),
    },
  ];

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Users-View-Title")}</span>{" "}
          {!isLoading ? (
            <span className="badge badge-pill badge-primary">
              {" "}
              {pagination.totalCount}
            </span>
          ) : null}
          {[master, admin, support, owner, manager].includes(
            Number(roleId)
          ) && (
            <button
              className={
                "btn btn-primary float-right" + (isMobile ? " btn-sm" : "")
              }
              onClick={handleToAdd}
            >
              <span
                className="icon icon-cancel web-hidden"
                style={{ transform: "rotate(45deg)" }}
              ></span>{" "}
              <span className="mob-hidden">
                {translator("Users-View-AddUser")}
              </span>
            </button>
          )}
        </div>

        <div className="card-body">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Users-View-Filters")}
            </legend>
            <form
              className="row"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              {localStorage.getItem("tenantId") === "null" && (
                <div className="form-group col-lg-3 col-md-4 col-xs-12">
                  <label>{translator("Users-Create-Tenant")}</label>
                  <AsyncSelect
                    name="tenantId"
                    onChange={(event) => {
                      setIsLoading(true);
                      setTenantObj({
                        id: event.id,
                        label: event.label,
                        value: event.value,
                      });
                      setSearch({ ...search, tenantId: event.id });
                      setPagination({ ...pagination, pageIndex: 0 });
                    }}
                    defaultOptions={true}
                    loadOptions={promiseOptions}
                    placeholder={translator("Select-Tenant")}
                    value={tenantObj}
                  />
                </div>
              )}
              <div className="form-group col-lg-3 col-md-4 col-xs-12">
                <label>{translator("Users-View-Filter-FullName")}</label>{" "}
                <Tooltip text={translator("UserTooltip-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  value={search.searchText}
                  onChange={(event) => {
                    setIsLoading(true);
                    setSearch({ ...search, searchText: event.target.value });
                    setPagination({ ...pagination, pageIndex: 0 });
                  }}
                />
              </div>
              <div className="form-group col-lg-2 col-md-4 col-xs-12">
                <label className="labelCont mt-5">
                  <input
                    type="checkbox"
                    name="cashDefault"
                    checked={search.isDeactivated}
                    onChange={(event) => {
                      setSearch({
                        ...search,
                        isDeactivated: event.target.checked,
                      });
                      setPagination({ ...pagination, pageIndex: 0 });
                    }}
                  />
                  <span className="checkmark"></span>
                </label>
                <span>{translator("POS-ShowDeactivated")}</span>
              </div>
            </form>
          </fieldset>
          <ListAdminButtons
            selectedItemsLength={selectedItems.length}
            handleToDetail={handleToDetail}
            handleToUpdate={
              [cashier, accountant].includes(Number(roleId))
                ? null
                : handleToUpdate
            }
            handleDelete={
              [cashier, accountant].includes(Number(roleId))
                ? null
                : () => setShowDeleteModal(true)
            }
            handleRefresh={handleRefresh}
          />

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={users}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}
        </div>
      </div>
      <DeleteModal
        show={showDeleteModal}
        handleHide={handleHideDeleteModal}
        title={translator("Users-DeleteModal-Title")}
        text={translator("Users-DeleteModal-Text")}
        confirmDelete={confirmDelete}
      />
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </div>
  );
};
export default Index;
